query getDeviceDataPermissionsForInstallationId {
  installationIdDataPermissions: getDeviceDataPermissionsForInstallationId {
    id
    type
    consent
  }
}
